import * as api from '@sophocles/api/customerSettings';
import { createSettingsFeature } from '@sophocles/features/_settings/createSettingsFeature';

const feature = createSettingsFeature({
  name: 'customerSettings',
  idKey: 'customerId',
  api: { fetch: api.fetchCustomerSettings, patch: api.patchCustomerSettings },
});

// Top-level + per-section hooks.
export const useCustomerSettings = feature.useSettings;
export const useCustomerInstructions = feature.useSection('instructions');

export default feature.reducer;
